import { Breadcrumbs } from "components/breadcrumbs";
import { AdminAccountRoleForm } from "./components";
import { IAdminAccountRoleDetail, IAdminAccountRoleForm } from "interfaces";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FullScreenLoading } from "components/fullScreenLoading";

export const EditAdminAccountRole : React.FC = () => {
  const navigate = useNavigate();
  const { mutate, isLoading: isUpdating } = useUpdate();
  const parse = useParse();
  const { params } = parse();
  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IAdminAccountRoleDetail>({
    resource: "admin-account/role",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const roleDetail = data?.data ?? null;

  const onSubmit = (values: IAdminAccountRoleForm) => {
    const submitValues = {...values};
    mutate({
      resource: "admin-account/role",
      id: params?.id,
      meta: {
        ignoreResourceWrapper: true
      },
      values: {
        ...submitValues
      },
    },
    {
      onSuccess: () => {
        toast.success("Update successfully");
        navigate(`/admin-accounts/roles/${params?.id}`);
      },
    });
  }
  
  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Role" />
      {roleDetail ? <AdminAccountRoleForm onSubmit={onSubmit} defaultValue={roleDetail} /> : <></>}
      {(isFetching && isPreviousData) || isUpdating ? <FullScreenLoading /> : <></>}
    </div>
  );
}